var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"clearable":"","items":_vm.itensCargos,"label":_vm.$t('Cargo'),"item-text":"descricao","return-object":""},model:{value:(_vm.cargo),callback:function ($$v) {_vm.cargo=$$v},expression:"cargo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }